import React from 'react';
import * as UIcons from '@iconscout/react-unicons';
import { Bell } from 'assets/icons';

export default function Notifications({handleClick}) {
  return (
    <div className="fixed top-[65px] md:absolute md:w-80 bg-white right-0 md:top-[60px] md:rounded-lg shadow-xl z-30">
      <span className="drop-reference"></span>
      
      <div className="text-secondary w-full relative p-3 flex items-center border-b">
        <Bell classList="w-6 h-6 mr-2" />
        <h5 className="text-lg font-bold">Notifications</h5>

        <UIcons.UilTimes 
          className="absolute right-2 md:hidden" 
          onClick={ handleClick }  
        />
      </div>

      <ul className="py-2 px-3 divide-y overflow-y-scroll">
        
        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>

        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>

        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>

        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>

        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>

        <li className="flex w-full p-3  cursor-pointer flex-col text-left">
          <p className="mb-3">This is a sentence about notification. about two lines right here</p>
          <span className="text-xs">2 days ago</span>
        </li>
      </ul>
    </div>
  )
}
